module.exports = __webpack_public_path__ + "videos/mts-main-products-courses.23157c7.webm";